<script lang="ts" setup>
import type { Props } from './types'
import { deepCopy } from '@/utils/objects'
import ProjectListButton from '@/components/ProjectListButton/index.vue'

defineProps<Props>()
const emit = defineEmits(['actionable-click'])
</script>

<script lang="ts">
export default {
  name: 'AppAiChatPassiveRecommendationWithImages'
}
</script>

<template>
  <div class="chat-passive-recommendation-with-images">
    <p
      v-if="recommendations.message"
      class="chat-passive-recommendation-with-images__message">
      {{ recommendations.message }}
    </p>

    <ProjectListButton
      :id="`chat-passive-recommendation-with-images-${recommendations.reference}`"
      :data-lh-id="`chat-passive-recommendation-with-images-${recommendations.reference}`"
      :listings="recommendations.results"
      class="chat-passive-recommendation-with-images__button cursor-pointer my-12"
      @click="() => emit('actionable-click', deepCopy(recommendations))" />
  </div>
</template>
